<script lang="ts">
	import GradientBorder from '$lib/util/GradientBorder.svelte';
	import _ from 'lodash';
	import { fly } from 'svelte/transition';
	import {
		currentSeasonObject,
		notificationsClosedForOngoingCompetitions
	} from '$lib/home/tradingRewards/store';
	import TimerInline from '$lib/util/TimerInline.svelte';
	import type { CompetitionConfig } from '$lib/types/leaderboard';
	import { onMount } from 'svelte';
	import { getCompetitionConfig, setCompetitionConfig } from '$lib/data/leaderboard';
	import { goto } from '$app/navigation';
	import type { Level } from '$lib/types/tradingRewards';
	import { competitionLevelSelected, currentCompetitionId } from '$lib/leaderboard/store';

	export let competitionId: string;

	function acknowledgeNotification() {
		notificationsClosedForOngoingCompetitions.set(
			$notificationsClosedForOngoingCompetitions.concat([competitionId])
		);
	}

	function openCompetition() {
		$currentCompetitionId = competitionId;
		$competitionLevelSelected = competitionLevels[0];
		acknowledgeNotification();
		goto('trading-season?section=competitions');
	}

	let competition: CompetitionConfig | undefined;
	let competitionLevels: Array<Level>;
	let competitionHeader = '';
	$: if ($currentSeasonObject && competitionId) {
		competitionLevels = $currentSeasonObject.levels.filter((x) =>
			x.ongoingCompetitions.includes(competitionId)
		);
		if (competitionLevels.length > 1) {
			competitionHeader = `Levels ${competitionLevels[0].level} - ${
				competitionLevels[competitionLevels.length - 1].level
			}`;
		} else {
			competitionHeader = `Level ${competitionLevels[0].level}`;
		}
	}
	onMount(async () => {
		competition = await getCompetitionConfig(competitionId);
	});
</script>

{#if competition}
	<button
		in:fly|global={{ x: 200, duration: 500, delay: 1000 }}
		out:fly|global={{ x: 200, duration: 500, delay: 500 }}
		class="absolute bottom-0 right-0 w-full sm:w-auto cursor-pointer"
		on:click={openCompetition}
		on:keydown={openCompetition}
	>
		<GradientBorder
			gradient="bg-fx-gradient-6"
			paddingClass="p-px"
			borderRadius="rounded-2xl squircle-2xl"
			outerClassList="w-full my-4"
			innerClassList="flex justify-center items-center bg-fx-black text-fx-white w-full"
		>
			<div class="bg-fx-gradient-8-50 w-full flex h-full rounded-xl squircle-xl">
				<img
					src="rewards/competition.png"
					alt="op_coin"
					class="h-28 -mr-2 rounded-xl squircle-xl"
				/>

				<div
					class="bg-fx-gradient-8 rounded-2xl squircle-2xl op-season-countdown-blur w-full lg:max-h-fit flex flex-col sm:flex-row justify-between px-4 py-2 sm:gap-10 gap-4"
				>
					<div class="flex flex-col items-start justify-center gap-1">
						<div class="text-fx-cyan text-xl font-semibold whitespace-nowrap">Competition</div>
						<div class="text-fx-grey-400 text-xs font-semibold">
							{competitionHeader}
						</div>
					</div>
					<div class="flex flex-col sm:items-end justify-center gap-1">
						{#if competition.startTimestamp < Date.now() / 1000}
							<div class="text-fx-gradient-22 text-xs font-semibold">Live</div>
						{:else}
							<div class="text-fx-gradient-22 text-xs">Starts in:</div>
							<div class="flex gap-2.5 items-center">
								<TimerInline countdownTo={competition.startTimestamp} />
							</div>
						{/if}
					</div>
				</div>
				<img
					src="rewards/notif_close.png"
					alt="close"
					class="h-6 w-6 mr-4 mt-2 cursor-pointer hover:rotate-90"
					on:click|stopPropagation={acknowledgeNotification}
					on:keydown|stopPropagation={acknowledgeNotification}
				/>
			</div>
		</GradientBorder>
	</button>
{/if}
